export enum ProductCategory {
  CommercialEnergyStorageSystems = 'Commercial Energy Storage Systems',
  ResidentialEnergyStorageSystems = 'Residential Energy Storage Systems',
  CentralizedPVStorageSystems = 'Centralized PV + Storage Systems',
  DistributedPVStorageSystems = 'Distributed PV + Storage Systems',
  SpecialtyMobilePowerSystems = 'Specialty Mobile Power Systems',
}

export enum ProductTag {
  ESS = 'ESS',
  Inverter = 'Inverter',
  PV = 'PV',
  MobilePower = 'Mobile Power',
}
